module.exports = __webpack_public_path__ + "static/media/CourseBackground.1f02a85d.svg";